const themeConfig = {
  version: "0.0.1",
  theme: "light", // light - dark
  contentWidth: "full", // full - boxed
  sidebarCollapsed: true, // true if you want to initialize the sidebar as collapsed
  sidebarCollapseButton: true,
  layout: "VerticalLayout", // VerticalLayout - HorizontalLayout - FullLayout
  navigationFull: false,
  navigationBg: false,
  direction: "ltr", // ltr - rtl
  language: "fr", // en - fr
};

export default themeConfig;
